import React from 'react';
import axios from 'axios';
import ShowMoreText from 'react-show-more-text';
import {IndexLink, Link, withRouter} from 'react-router';
import {connect} from 'react-redux';

class ProfileReviews extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            rst: [],
            totalResults: 0,
            itemFeedback: [],
            loading: false,
            profileId: this.props.profileId,
        };
    }

    componentDidMount = () => {
        this.setState({loading: true}, () => {
            this.getFeedback();
        });
    }

    componentWillReceiveProps = (nextProps) => {
        this.setState({
            profileId: nextProps.profileId
        });
    }

    getFeedback = () => {
        let url = "/code/api_interships.php?api=getFeedback&profileId="+this.state.profileId;
        axios.get(url)
            .then(response => {

                var rst = response.data;

                if (parseInt(rst.status) === 1) {
                    this.setState({ rst: rst, totalResults: rst.totalResults }, () => {
                        this.renderFeedback()
                    });
                }
                else {
                    this.setState({rst: [], itemFeedback: [], totalResults: 0});
                }
            })
    }

    executeOnClick = (isExpanded) => {
    }

    renderFeedback = () => {
        let rst = this.state.rst;
        if (rst.results !== undefined) {
            var itemFeedback = this.state.itemFeedback;
            var totalResults = rst.totalResults + itemFeedback.length;
            if (totalResults > 0) {
                var i = 0;
                for (var item of rst.results) {
                    var s_profile = item.s_profile
                    i++;
                    var avatar = "/static/img/appimg/common-noavatar-sm.jpg"
                    if (parseInt(s_profile.image_avatar_account) > 0) {
                        avatar = s_profile.avatar
                        while(avatar.charAt(0) === '/')
                        {
                            avatar = avatar.substring(1);
                        }
                        avatar = "/" + avatar;
                    }

                    var skillArr = []
                    for(var item2 of s_profile.skills)
                    {
                        skillArr.push(
                            <li key={item.id_account+"_"+item2.id_skill} className="label-20dp mr2 mgt2"> {item2.name_skill}</li>
                        );
                    }

                    itemFeedback.push(
                        <section key={"feedback-"+i+item.student_account} className="artdeco-card ember-view mt4 p4">
                            <div>
                                <div className="p4">
                                    <div className="display-flex justify-space-between">
                                        <div id="ember56"
                                             className="artdeco-entity-lockup artdeco-entity-lockup--size-4 ember-view">
                                            <div id="ember57"
                                                 className="artdeco-entity-lockup__image artdeco-entity-lockup__image--type-circle ember-view">
                                                <a className="app-aware-link"
                                                   aria-label="View Maxine Bernstein’s profile">
                                                    <div className="ivm-image-view-model   ">
                                                        <div
                                                            onClick={this.handleClickGoto.bind(this, "/profile/"+item.student_account)}
                                                            className="ivm-view-attr__img-wrapper ivm-view-attr__img-wrapper--use-img-tag display-flex">
                                                            <img width="56"
                                                                 src={avatar}
                                                                 loading="lazy" height="56" alt="Maxine Bernstein"
                                                                 id="ember58"
                                                                 className="ivm-view-attr__img--centered EntityPhoto-circle-4  lazy-image ember-view"/>
                                                        </div>
                                                    </div>
                                                </a>
                                            </div>
                                            <div id="ember59" className="artdeco-entity-lockup__content ember-view">
                                                <div id="ember60"
                                                     className="artdeco-entity-lockup__title ember-view">
                                                        <span className="t-black t-bold">
                                                            <span aria-hidden="true">
                                                              {s_profile.full_name}
                                                            </span>
                                                        </span>
                                                </div>
                                                <div id="ember61"
                                                     className="artdeco-entity-lockup__badge ember-view t-black--light">
                                                    <span className="artdeco-entity-lockup__degree" aria-hidden="true">&nbsp;</span>
                                                </div>
                                                <div id="ember62"
                                                     className="artdeco-entity-lockup__subtitle ember-view">
                                                    <span className="t-14 t-black--light">
                                                        <span dir="ltr">
                                                              <span aria-hidden="true">
                                                                {s_profile.name_university}
                                                              </span>
                                                        </span>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <div id="ember63"
                                                 className="artdeco-dropdown artdeco-dropdown--placement-bottom artdeco-dropdown--justification-right ember-view smp-service-pages-review-card__overflow-actions">
                                                <button aria-expanded="false" aria-label="See more options"
                                                        id="ember64"
                                                        className="no-width-height artdeco-dropdown__trigger artdeco-dropdown__trigger--placement-bottom ember-view artdeco-button artdeco-button--tertiary artdeco-button--muted smp-service-page-reviews-overflow-actions__trigger-js-only"
                                                        type="button" tabIndex="0">
                                                    <li-icon aria-hidden="true" type="overflow-web-ios" size="small">
                                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"
                                                             data-supported-dps="16x16" fill="currentColor"
                                                             className="mercado-match" width="16" height="16"
                                                             focusable="false">
                                                            <path d="M3 9.5A1.5 1.5 0 114.5 8 1.5 1.5 0 013 9.5zM11.5 8A1.5 1.5 0 1013 6.5 1.5 1.5 0 0011.5 8zm-5 0A1.5 1.5 0 108 6.5 1.5 1.5 0 006.5 8z"></path>
                                                        </svg>
                                                    </li-icon>
                                                </button>
                                                <div tabIndex="-1" aria-hidden="true" id="ember65"
                                                     className="artdeco-dropdown__content artdeco-dropdown--is-dropdown-element artdeco-dropdown__content--has-arrow artdeco-dropdown__content--arrow-right artdeco-dropdown__content--justification-right artdeco-dropdown__content--placement-bottom ember-view smp-service-pages-reviews-overflow-actions__dropdown-content">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <ul className="display-flex flex-wrap mt3">
                                        {skillArr}
                                    </ul>
                                    <div className="display-flex mt3">
                                        <div className="rating-container theme-krajee-fa rating-animate">
                                            <div className="rating">
                                                <span className="empty-stars">
                                                    <span className="star">
                                                        <i className="fa fa-star-o"></i>
                                                    </span>
                                                    <span className="star">
                                                        <i className="fa fa-star-o"></i>
                                                    </span>
                                                    <span className="star">
                                                        <i className="fa fa-star-o"></i>
                                                    </span>
                                                    <span className="star">
                                                        <i className="fa fa-star-o"></i>
                                                    </span>
                                                    <span className="star">
                                                        <i className="fa fa-star-o"></i>
                                                    </span>
                                                </span>
                                                <span className="filled-stars" style={{width: item.rate_precent+"%"}}>
                                                    <span className="star">
                                                        <i className="fa fa-star"></i>
                                                    </span>
                                                    <span className="star">
                                                        <i className="fa fa-star"></i>
                                                    </span>
                                                    <span className="star">
                                                        <i className="fa fa-star"></i>
                                                    </span>
                                                    <span className="star">
                                                        <i className="fa fa-star"></i>
                                                    </span>
                                                    <span className="star">
                                                        <i className="fa fa-star"></i>
                                                    </span>
                                                </span>
                                            </div>
                                        </div>
                                        <div className="mgt4">
                                            <span className="t-14 t-bold t-black--light ml2">{item.rate} · </span>
                                            <span className="t-12 t-black--light">
                                            <span dir="ltr">
                                              <span aria-hidden="true">
                                                {item.created_endcontract}
                                              </span>
                                            </span>
                                          </span>
                                        </div>
                                    </div>
                                    <p id="ember66"
                                       className="smp-service-pages-review-card__see-more mt3 text-body-small-open t-black break-words ember-view">
                                        <span className="lt-line-clamp__line">
                                            <ShowMoreText
                                                lines={2}
                                                more='Show more'
                                                less='Show less'
                                                anchorClass=''
                                                onClick={this.executeOnClick}
                                            >
                                                {item.comment_puplic_endcontract}
                                            </ShowMoreText>
                                        </span>
                                    </p>
                                </div>
                            </div>
                        </section>
                    );
                }
            }
            else {
                itemFeedback.push(
                    <div key={"tracker-empty"} className="row item_box_bottom">
                    </div>
                );
            }
            this.setState({itemFeedback: itemFeedback});
        }
    }

    handleClickGoto = (url, evt) => {
        this.props.router.push(url)
    }

    render() {
        let rst = this.state.rst;

        return (
            <div id="root-linkedin">
                <section id="coach-profile-student-feedback" className="artdeco-card ember-view mt4">
                    <div>
                        <div className="pv4 ph5 profile_content_wrapper">
                            <div className="title_box">
                                <img src="/static/img/appimg/icon_skill.png"/>
                                <div className="title">Student Feedback</div>
                            </div>
                            <div className="pt1">
                                <h2 className="t-black t-bold t-32"> {rst.rate} <span
                                    className="t-black--light t-normal t-24"> out of 5 </span>
                                </h2>
                                <div className="display-flex mt3">
                                    <div className="rating-container theme-krajee-fa rating-animate">
                                        <div className="rating bigger">
                                            <span className="empty-stars">
                                                <span className="star">
                                                    <i className="fa fa-star-o"></i>
                                                </span>
                                                <span className="star">
                                                    <i className="fa fa-star-o"></i>
                                                </span>
                                                <span className="star">
                                                    <i className="fa fa-star-o"></i>
                                                </span>
                                                <span className="star">
                                                    <i className="fa fa-star-o"></i>
                                                </span>
                                                <span className="star">
                                                    <i className="fa fa-star-o"></i>
                                                </span>
                                            </span>
                                            <span className="filled-stars" style={{width: rst.rate_precent+"%"}}>
                                                <span className="star">
                                                    <i className="fa fa-star"></i>
                                                </span>
                                                <span className="star">
                                                    <i className="fa fa-star"></i>
                                                </span>
                                                <span className="star">
                                                    <i className="fa fa-star"></i>
                                                </span>
                                                <span className="star">
                                                    <i className="fa fa-star"></i>
                                                </span>
                                                <span className="star">
                                                    <i className="fa fa-star"></i>
                                                </span>
                                            </span>
                                        </div>
                                    </div>
                                    <div className="mgt6">
                                        <span className="t-16 t-black--light ml2"> ({this.state.totalResults} reviews) </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="smp-service-pages-rating-breakdown__container t-14 t-black--light">
                            <h2 className="t-14 t-black--light t-bold mb4"> Rating breakdown </h2>
                            <ul className="smp-service-pages-rating-breakdown__subratings-container">
                                <li className="smp-service-pages-rating-breakdown__subrating">
                                    <span className="mb3"> Project satisfaction </span>
                                    <hr className="artdeco-divider flex-1 mh2"/>
                                        <span className="mr1"> {rst.rate1} </span>
                                        <div>
                                            <li-icon aria-hidden="true" type="star-filled-icon"
                                                     class="smp-service-pages-rating-breakdown__star-icon"
                                                     size="small">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"
                                                     data-supported-dps="16x16" fill="currentColor"
                                                     className="mercado-match" width="16" height="16"
                                                     focusable="false">
                                                    <path d="M8 .5l2.27 4.61 5.06.74-3.66 3.58.86 5.07L8 12.11 3.47 14.5l.86-5.07L.67 5.85l5.06-.74z"></path>
                                                </svg>
                                            </li-icon>
                                        </div>
                                </li>
                                <li className="smp-service-pages-rating-breakdown__subrating">
                                    <span className="mb3"> Knowledge </span>
                                    <hr className="artdeco-divider flex-1 mh2"/>
                                        <span className="mr1"> {rst.rate2} </span>
                                        <div>
                                            <li-icon aria-hidden="true" type="star-filled-icon"
                                                     class="smp-service-pages-rating-breakdown__star-icon"
                                                     size="small">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"
                                                     data-supported-dps="16x16" fill="currentColor"
                                                     className="mercado-match" width="16" height="16"
                                                     focusable="false">
                                                    <path d="M8 .5l2.27 4.61 5.06.74-3.66 3.58.86 5.07L8 12.11 3.47 14.5l.86-5.07L.67 5.85l5.06-.74z"></path>
                                                </svg>
                                            </li-icon>
                                        </div>
                                </li>
                                <li className="smp-service-pages-rating-breakdown__subrating">
                                    <span className="mb3"> Communication </span>
                                    <hr className="artdeco-divider flex-1 mh2"/>
                                        <span className="mr1"> {rst.rate6} </span>
                                        <div>
                                            <li-icon aria-hidden="true" type="star-filled-icon"
                                                     class="smp-service-pages-rating-breakdown__star-icon"
                                                     size="small">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"
                                                     data-supported-dps="16x16" fill="currentColor"
                                                     className="mercado-match" width="16" height="16"
                                                     focusable="false">
                                                    <path d="M8 .5l2.27 4.61 5.06.74-3.66 3.58.86 5.07L8 12.11 3.47 14.5l.86-5.07L.67 5.85l5.06-.74z"></path>
                                                </svg>
                                            </li-icon>
                                        </div>
                                </li>
                                <li className="smp-service-pages-rating-breakdown__subrating">
                                    <span className="mb3"> Timeliness </span>
                                    <hr className="artdeco-divider flex-1 mh2"/>
                                        <span className="mr1"> {rst.rate7} </span>
                                        <div>
                                            <li-icon aria-hidden="true" type="star-filled-icon"
                                                     class="smp-service-pages-rating-breakdown__star-icon"
                                                     size="small">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"
                                                     data-supported-dps="16x16" fill="currentColor"
                                                     className="mercado-match" width="16" height="16"
                                                     focusable="false">
                                                    <path d="M8 .5l2.27 4.61 5.06.74-3.66 3.58.86 5.07L8 12.11 3.47 14.5l.86-5.07L.67 5.85l5.06-.74z"></path>
                                                </svg>
                                            </li-icon>
                                        </div>
                                </li>
                            </ul>
                        </div>

                    </div>
                    <section className="ph5 pb5">
                        {this.state.itemFeedback}
                    </section>
                </section>
            </div>
        )
    }
}

ProfileReviews.propTypes = {
    router: React.PropTypes.shape({
        push: React.PropTypes.func.isRequired
    }).isRequired
};
const mapStateToProps = function (store) {
    return {
        user: store.userState.user,
        socket: store.msgState.socket
    };
};

export default connect(mapStateToProps)(withRouter(ProfileReviews));


/** WEBPACK FOOTER **
 ** ./src/client/app/appcomponents/commons/profile/profile_review.js
 **/